import type {KeyTextField, LinkField, SelectField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import Link from 'next/link'
import {useLinkResolver} from 'prismicio'
import {EVENTS, track} from 'src/common/helpers'
import type {IconType} from 'src/common/Icon'
import {Icon} from 'src/common/Icon'

export const ContentSection = ({
  highlight_1_icon,
  highlight_2_icon,
  highlight_1_title,
  highlight_1_description,
  highlight_2_title,
  highlight_2_description,
  buttonLabel,
  primary_button_url,
  index,
  pageUid,
  componentIndex,
}: {
  highlight_1_icon: SelectField<'Up arrow' | 'Down arrow' | 'Plus bold'>
  highlight_2_icon: SelectField<'Up arrow' | 'Down arrow' | 'Plus bold'>
  highlight_1_title: KeyTextField
  highlight_1_description: KeyTextField
  highlight_2_title: KeyTextField
  highlight_2_description: KeyTextField
  buttonLabel?: string
  primary_button_url: LinkField
  enableReskin?: boolean
  index?: number
  pageUid?: string
  componentIndex?: number
}) => {
  const {linkResolver} = useLinkResolver()
  const icon1 = highlight_1_icon?.toLowerCase().replace(/ /g, '-') as IconType
  const icon2 = highlight_2_icon?.toLowerCase().replace(/ /g, '-') as IconType

  return (
    <div className="flex flex-col gap-6 md:gap-10">
      <div className="flex gap-12 max-sm:pb-2">
        {isFilled.keyText(highlight_1_title) && (
          <div className="flex flex-col">
            <div className="flex items-center gap-1">
              <Icon name={icon1} className="size-3 text-green-neon" />
              <p className="text-body-l font-medium text-moss-white">{highlight_1_title}</p>
            </div>
            <span className="text-20 font-medium leading-6 text-moss-white/[70%]">{highlight_1_description}</span>
          </div>
        )}
        {isFilled.keyText(highlight_2_title) && (
          <div className="flex flex-col">
            <div className="flex items-center gap-1">
              <Icon name={icon2} className="size-3 text-green-neon" />
              <p className="text-body-l font-medium text-moss-white">{highlight_2_title}</p>
            </div>
            <span className="text-20 font-medium leading-6 text-moss-white/[70%]">{highlight_2_description}</span>
          </div>
        )}
      </div>
      {isFilled.link(primary_button_url) && (
        <Link
          href={linkResolver(primary_button_url, 'primary-button-content-section')}
          {...(primary_button_url.link_type === 'Document'
            ? {
                locale: primary_button_url.lang || 'en-us',
              }
            : {})}
          onClick={() =>
            track({
              event: EVENTS.CLICK,
              mktgId: `customer-stories-${index}`,
              location: `component-${componentIndex}-customer-stories`,
              pageName: pageUid,
              dataType: 'customer-stories-button',
            })
          }
          className="relative z-20 flex h-[38px] w-fit items-center gap-[14px] rounded-[4px] border border-moss-grey-150 bg-moss-white pl-[14px] pr-[7px] transition-colors duration-100 group-hover/slide:bg-moss-grey-100"
        >
          <span className="text-button-s uppercase text-black">{buttonLabel || 'Read their story'}</span>
          <div className="flex size-6 items-center justify-center rounded-sm bg-green-neon">
            <Icon name="arrow" className="h-2 w-2.5 text-green-dark" />
          </div>
        </Link>
      )}
    </div>
  )
}
